//deskarista ylöspäin tuotekuvassa zoomaus

$('.nav-search-btn').on('click', function() {
  toggleShopSearchField();
});

$('.searchBackground').on('click', function() {
  toggleShopSearchField();
});

function toggleShopSearchField() {
  $('.nav-search').toggle();
  $('.menu-bottommenu-ammattilaisille-container').toggle();
  $('.nav-link-shop').toggle();
  //$('.nav-link-button').toggle();
  $('.nav-search-btn .showSearch').toggle();
  $('.nav-search-btn .closeSearch').toggle();
  $('.searchBackground').toggle();
}



// WEBPACK FOOTER //
// ./scripts/autoload/woocommerce.js